const mutation = /* GraphQL */ `
  mutation SetReservationCartMutation($input: SetReservationCartInput!) {
    setReservationCart(input: $input) {
      reservation {
        cart {
          plan
          numDevices
          numDevicesUsbC
          numDevicesLightning
          numCloudUsers
          cloudSubscriptionYears
          warrantyYears
          cloudDicom
          shippingAddress {
            name
            line1
            line2
            city
            state
            postalCode
            country
            phone
            attention
          }
          shippingMethod
          devicesPrice
          devicesUsbCPrice
          devicesLightningPrice
          additionalCloudUsersPrice
          baseCloudUsersPrice
          baseNumCloudUsers
          additionalNumCloudUsers
          cloudUsersPrice
          extendedWarrantiesPrice
          shippingPrice
          taxPrice
          totalPrice
        }
      }
    }
  }
`;

function commit(environment, reservationId, cart) {
  return environment.commitMutation(mutation, {
    input: { reservationId, ...cart },
  });
}

export default { commit };
